'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderComponent = exports.orderComponent = {
    template: require('./order.html'),
    bindings: {
        cart: '<',
        wholeSalers: '<',
        customerAccounts: '<'
    },
    controllerAs: 'vm',
    controller: ["$rootScope", "common", "gettextCatalog", "cartService", "$state", "exceptionService", "Analytics", "authService", "userService", function checkoutOrderController($rootScope, common, gettextCatalog, cartService, $state, exceptionService, Analytics, authService, userService) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.createOrders = createOrders;
        vm.specialOrderProducts = [];
        vm.isSpecialOrder = false;
        vm.isCreateOrderDisabled = isCreateOrderDisabled;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.selectedWholeSaler = null;
        vm.selectedCustomerAccount = null;
        vm.hasSpecialOrderProducts = null;
        vm.showCustomerAccounts = false;
        vm.user = null;

        function init() {
            common.navigationMenu.clearActiveMenu();

            common.setTitle(gettextCatalog.getString('Place order'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/cart/order', gettextCatalog.getString('Place order'));

            //get apb number
            var tenants = authService.customUserInfo.tenants;
            var activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService.user.SAUK || !!t.id && t.id === parseInt(authService.user.BuyerID, 10);
            });
            vm.apbNumber = activeTenant.apbNumber;
            userService.getMyAccount().then(function (u) {
                vm.user = u;
            });
            //get list of products with special order products
            vm.cart.sellers.forEach(function (seller) {
                seller.products.map(function (sellerProduct) {
                    if (sellerProduct.allowSpecial && seller.canOrderSpecial) {
                        vm.specialOrderProducts.push(sellerProduct);
                    }
                });
            });

            vm.specialOrderProducts.length === 0 ? vm.hasSpecialOrderProducts = false : vm.hasSpecialOrderProducts = true;

            setDefaultWholeSaler();
            setShowCustomerAccounts();
            setDefaultCustomerAccount();
        }

        function setDefaultWholeSaler() {
            vm.selectedWholeSaler = vm.wholeSalers.find(function (wholeSaler) {
                return String(wholeSaler.id) === authService.defaultWholesalerId;
            });
        }

        function setShowCustomerAccounts() {
            var hasMultipleCustomerAccounts = vm.customerAccounts.length > 1;
            var hasFebelcoSellerProducts = !!vm.cart.sellers.find(function (seller) {
                return seller.isVipSeller;
            });

            vm.showCustomerAccounts = hasFebelcoSellerProducts && hasMultipleCustomerAccounts;
        }

        function setDefaultCustomerAccount() {

            if (vm.customerAccounts && vm.customerAccounts.length) {
                var defaultAccount = vm.customerAccounts.find(function (x) {
                    return x.number === authService.user.FebelcoCustomerNumber;
                });
                vm.selectedCustomerAccount = defaultAccount || vm.customerAccounts[0];
            }
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }

        function createOrders() {

            angular.forEach(vm.cart.sellers, function (seller) {
                angular.forEach(seller.products, function (product) {
                    Analytics.addProduct(product.id, product.name, product.type, product.brand, '', product.totalPriceWithDiscount, product.quantity, '', '', {
                        sellerId: product.sellerId,
                        sellerName: product.sellerName,
                        discountId: product.discountId
                    });
                });
            });

            cartService.createOrders(vm.isSpecialOrder, vm.selectedWholeSaler, vm.selectedCustomerAccount).then(function (orders) {
                orders.forEach(function (order) {
                    Analytics.trackTransaction(order.orderNumber, order.sellerName, order.totalPrice, '', '', '', '', '', '');
                });
                cartService.getFromServerCheckoutCart().then(function (cart) {
                    $state.go('checkout-confirmation', {
                        orders: orders,
                        disabledSellers: cart.disabledSellers
                    });
                });
            }).catch(function () {
                var msg = gettextCatalog.getString('An error occurred during the confirmation of the order. Please contact the customer support.');
                exceptionService.logException(msg);
            });
        }

        function isCreateOrderDisabled() {
            if (vm.isFebelcoCustomer()) {
                if (vm.hasSpecialOrderProducts) {
                    return vm.isSpecialOrder ? false : true;
                } else {
                    return false;
                }
            } else {
                return vm.selectedWholeSaler ? false : true;
            }
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/checkout/order.js
// module id = 910
// module chunks = 0